import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["label"];
import { isString } from 'underscore';
import LegalConsentKeys from './constants/legalConsentKeys';
import reduceObject from 'forms-utils-lib/utils/object/reduceObject';
const isConsentCheckboxes = key => key === LegalConsentKeys.COMMUNICATION_CONSENT_CHECKBOXES;
const replaceUnModifiedString = (key, currentValue, updatedLegalConsent, oldLegalConsent, newLegalConsent) => oldLegalConsent[key] === currentValue ? Object.assign({}, updatedLegalConsent, {
  [key]: newLegalConsent[key]
}) : updatedLegalConsent;
const replaceUnModifiedConsentCheckboxes = (currentConsentCheckboxes, updatedLegalConsent, oldLegalConsent, newLegalConsent) => {
  const oldConsentCheckboxes = oldLegalConsent[LegalConsentKeys.COMMUNICATION_CONSENT_CHECKBOXES];
  const newConsentCheckboxes = newLegalConsent[LegalConsentKeys.COMMUNICATION_CONSENT_CHECKBOXES];
  const updatedConsentCheckboxes = currentConsentCheckboxes.map((_ref, index) => {
    let {
        label
      } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    return Object.assign({
      label: oldConsentCheckboxes[index] && newConsentCheckboxes[index] && label === oldConsentCheckboxes[index].label ? newConsentCheckboxes[index].label : label
    }, rest);
  });
  return Object.assign({}, updatedLegalConsent, {
    [LegalConsentKeys.COMMUNICATION_CONSENT_CHECKBOXES]: updatedConsentCheckboxes
  });
};
const getTranslatedLegalConsent = (currentLegalConsent, oldLegalConsent, newLegalConsent) => {
  return reduceObject(currentLegalConsent, (updatedLegalConsent, value, key) => {
    if (isString(value)) {
      return replaceUnModifiedString(key, value, updatedLegalConsent, oldLegalConsent, newLegalConsent);
    }
    if (isConsentCheckboxes(key)) {
      return replaceUnModifiedConsentCheckboxes(value, updatedLegalConsent, oldLegalConsent, newLegalConsent);
    }
    return updatedLegalConsent;
  });
};
export default getTranslatedLegalConsent;